
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Alert } from "@/addons/Alert";
import { DateTime } from "luxon";
import { useConsultorioStore } from '@/store/consultorioStore';
import { globalStore } from '@/store/globalStore';
import { consultorioService } from '@/services/ConsultorioService';
import { http } from "@/config/HttpClient";
import { AxiosResponse } from "axios";

@Component({
	name: "FichaArtificiales",
})

export default class FichaArtificiales extends Vue {
	@Prop() paciente_id!: any
	private globalStore = globalStore();
	private consultorioStore = useConsultorioStore();
	private consultorioService = consultorioService.getInstance();
	
	valid = true;
	row = null;

	tamanos = [
		{title: 'Tamano Medium Soft 32-34', value: 'Tamano Medium Soft 32-34'},
		{title: 'Tamano Medium Bold 33-42', value: 'Tamano Medium Bold 33-42'},
		{title: 'Tamano Large Soft 35-45', value: 'Tamano Large Soft 35-45'},
		{title: 'Tamano Large Bold 05-43-44', value: 'Tamano Large Bold 05-43-44'}
	];
	colores = [
		{ title:'Blanco 01-110', value: 'Blanco 01-110' },
		{ title:'Blanco 1A-120', value: 'Blanco 1A-120' },
		{ title:'Blanco 2A-130', value: 'Blanco 2A-130' },
		{ title:'Blanco 1C-140', value: 'Blanco 1C-140' },
		{ title:'Amarillo 2B-210', value: 'Amarillo 2B-210' },
		{ title:'Amarillo 1D-220', value: 'Amarillo 1D-220' },
		{ title:'Amarillo 1E-230', value: 'Amarillo 1E-230' },
		{ title:'Amarillo 2C-240', value: 'Amarillo 2C-240' },
		{ title:'Cafe 3A-310', value: 'Cafe 3A-310' },
		{ title:'Cafe 5B-320', value: 'Cafe 5B-320' },
		{ title:'Cafe 2E-330', value: 'Cafe 2E-330' },
		{ title:'Cafe 3E-340', value: 'Cafe 3E-340' },
	]
	swEditar = false
	ficha = {
		paciente_id: 0,
		numero: '',
		tamanio: '',
		color: '',
	}
	items =  [];
	get loading(): boolean {
		return this.consultorioStore.loading;
	}
	get fichas(): any {
		return this.consultorioStore.fichas_artificiales;
	}
	mounted() {
		this.ficha.paciente_id = Number(this.$route.query.id)
		this.getFichasArtificiales();
	}
	
	editar(ficha:any){
		this.swEditar = true;
		this.ficha = ficha
	}
	guardar() {
		if (!this.$refs.form.validate()) {
      Alert.warning( `Lene todos los campos obligatorios (*)`)
      return;
    }
		Alert.confirm(`Se registrará la ficha de diente artificial`, 'Registrar Ficha?').then(async result => {
			if(result.isConfirmed){
				this.consultorioStore.loading = true;
				await this.consultorioService.registrarFichaArtificial(this.ficha)
				await this.getFichasArtificiales()
			}
		})
  }
	async getFichasArtificiales(){
		let param = {
			paciente_id: this.paciente_id
		}
		await this.consultorioService.getFichasArtificiales(param);
	}

	async seleccionarTamano() {
		if(this.ficha.tamanio) {
			switch (this.ficha.tamanio) {
				case 'Tamano Medium Soft 32-34':
					this.items = ['32','34']
					break;
				case 'Tamano Medium Bold 33-42':
					this.items = ['33','42']
					break;
				case 'Tamano Large Soft 35-45':
					this.items = ['35','45']
					break;
				case 'Tamano Large Bold 05-43-44':
					this.items = ['05','43','44']
					break;
				default:
					break;
			}
		}
	}
	async eliminar(id:number) {
		this.consultorioStore.loading = true;
		Alert.confirm(`Se eliminará la ficha de diente artificial`, 'Eliminar Ficha?').then(async result => {
			if(result.isConfirmed){
				await this.consultorioService.eliminarFichaArtificial(id).then(response => {
					this.getFichasArtificiales();
				})
			}
		})
		
	}
	
}

